import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { NutritionVitaminADiagramContent } from "./NutritionVitaminADiagram";
import { NutritionVitaminAKeyContent } from "./NutritionVitaminAKey";

const SvgNutritionVitaminADiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1344, 1594)}
      viewBox={diagramOnly ? "0 176 1024 1344" : "0 0 1024 1594"}
    >
      <g id="nutrition-vitamin_a-diagram+key" clipPath="url(#clip0_18284_196595)">
        <rect width={1024} height={diagramOnly ? 1344 : 1594} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <NutritionVitaminAKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <NutritionVitaminADiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18284_196595">
          <rect width={1024} height={1594} fill="white" />
        </clipPath>
        <clipPath id="clip1_18284_196595">
          <rect width={1024} height={1344} fill="white" transform="translate(0 176)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgNutritionVitaminADiagramKey;
